import { FieldError, FieldErrorsImpl, Merge } from "react-hook-form";

export type FormErrorMessage =
  | string
  | false
  | FieldError
  | Merge<FieldError, FieldErrorsImpl<any>>
  | undefined;

/**
 * react-hook-form's error.message isn't always a plain string — it can be a
 * FieldError (or a Merge of nested FieldErrors for field arrays/objects),
 * which would crash React ("Objects are not valid as a React child") if
 * rendered directly. Pulls out a safely-renderable string, or undefined.
 */
export function getErrorMessage(message: FormErrorMessage): string | undefined {
  if (typeof message === "string") return message;

  if (
    message &&
    typeof message === "object" &&
    "message" in message &&
    typeof message.message === "string"
  ) {
    return message.message;
  }

  return undefined;
}
